/*
 * Returns a demo if there's one available for the platform
 * We don't have the ability to show a live demo for mobile languages
 */
export const getActiveDemo = ({demos, languages}) => {
  if (!demos || (!languages.active && !languages.active.platform)) {
    return;
  }
  return demos[languages.active.platform];
};
